'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _levelToConsoleMethod, _levelToInstaceMethod;

var _envInfo = require('../constants/envInfo');

var _envInfo2 = _interopRequireDefault(_envInfo);

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SENTRY_FATAL = 'fatal';
var SENTRY_ERROR = 'error';
var SENTRY_WARNING = 'warning';
var SENTRY_INFO = 'info';

var levelToConsoleMethod = (_levelToConsoleMethod = {}, _defineProperty(_levelToConsoleMethod, SENTRY_FATAL, 'error'), _defineProperty(_levelToConsoleMethod, SENTRY_ERROR, 'error'), _defineProperty(_levelToConsoleMethod, SENTRY_WARNING, 'warn'), _defineProperty(_levelToConsoleMethod, SENTRY_INFO, 'info'), _levelToConsoleMethod);

var levelToInstaceMethod = (_levelToInstaceMethod = {}, _defineProperty(_levelToInstaceMethod, SENTRY_FATAL, 'fatal'), _defineProperty(_levelToInstaceMethod, SENTRY_ERROR, 'error'), _defineProperty(_levelToInstaceMethod, SENTRY_WARNING, 'warn'), _defineProperty(_levelToInstaceMethod, SENTRY_INFO, 'info'), _levelToInstaceMethod);

var Logger = function () {
  function Logger() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$isJasmine = _ref.isJasmine,
        isJasmine = _ref$isJasmine === undefined ? false : _ref$isJasmine,
        _ref$isProd = _ref.isProd,
        isProd = _ref$isProd === undefined ? _envInfo2.default.isProd : _ref$isProd,
        _ref$isDeployed = _ref.isDeployed,
        isDeployed = _ref$isDeployed === undefined ? _envInfo2.default.isDeployed : _ref$isDeployed,
        _ref$fingerprint = _ref.fingerprint,
        fingerprint = _ref$fingerprint === undefined ? null : _ref$fingerprint;

    _classCallCheck(this, Logger);

    this._isJasmine = isJasmine;
    this._isProd = isProd;
    this._isDeployed = isDeployed;
    this.defaultContext = {};

    if (fingerprint) {
      this.defaultContext.fingerprint = fingerprint;
    }

    Logger.createLogMethods(this);
  }

  _createClass(Logger, [{
    key: 'reportToSentry',
    value: function reportToSentry(message) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { level: 'warning' };

      if (this.isDeployed) {
        if (!this.isProd) {
          console.log('[' + context.level.toUpperCase() + '] (reported to Sentry) %s, %o', message, context);
        }

        if (!context.hasOwnProperty('level')) {
          context.level = 'warning';
        }

        _Raven2.default.captureMessage(new Error(message), context);
      }
    }
  }, {
    key: 'log',
    value: function log() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this._console.apply(this, ['log'].concat(args));
    }
  }, {
    key: 'debug',
    value: function debug() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this._console.apply(this, ['debug'].concat(args));
    }
  }, {
    key: '_console',
    value: function _console(type) {
      var _console2;

      if (this.isJasmine || this.isDeployed) {
        return;
      }

      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      (_console2 = console)[type].apply(_console2, args);
    }
  }, {
    key: 'isProd',
    get: function get() {
      return !this.isJasmine && this._isProd;
    }
  }, {
    key: 'isDeployed',
    get: function get() {
      return !this.isJasmine && this._isDeployed;
    }
  }, {
    key: 'isJasmine',
    get: function get() {
      return this._isJasmine;
    }
  }], [{
    key: 'createLogMethods',
    value: function createLogMethods(LoggerInstance) {
      [SENTRY_FATAL, SENTRY_ERROR, SENTRY_WARNING, SENTRY_INFO].forEach(function (level) {
        var consoleMethod = levelToConsoleMethod[level];
        var instanceMethod = levelToInstaceMethod[level];

        LoggerInstance[instanceMethod] = function (message) {
          for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            args[_key4 - 1] = arguments[_key4];
          }

          this._console(consoleMethod, [message].concat(args));
          var _args$ = args[0],
              context = _args$ === undefined ? {} : _args$;

          this.reportToSentry(message, _extends({
            level: level
          }, this.defaultContext, context));
        };
      });
    }
  }, {
    key: 'getLogger',
    value: function getLogger(name) {
      var loggerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (Object.prototype.toString.call(name) !== '[object String]') {
        throw new Error('getLogger should receive a string as the name argument');
      }

      loggerOptions.fingerprint = [name];

      return new Logger(_extends({}, loggerOptions));
    }
  }]);

  return Logger;
}();

exports.default = Logger;
module.exports = exports['default'];